import React, { useState } from 'react';
import { preloaderItem } from './styles';

export const SuggestionPreloader = () => {
  const [items] = useState(Array.from({ length: 7 }, (_, i) => i));

  return (
    <div data-qa="suggestion-preloader">
      {items.map((_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={`sp_${i}`} className={preloaderItem} />
      ))}
    </div>
  );
};
